export enum Autocomplete {
  Search = 'Sök',
  RoomsMin = 'Minst antal rum',
  PickRoom = 'Välj antal rum',
  EstateTypeLabel = 'Hur vill du bo?',
  PickType = 'Välj bostadstyp',
  LocationPick = 'Var vill du bo?',
}
